import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Terms.module.scss';
import PartialReadOnlyInput from './PartialReadOnlyInput/PartialReadOnlyInput';
import { Currency, maxMobileSize } from '../../../../../utils/constants';
import { useWindowSize } from '../../../../../utils/hooks';

function Terms(props) {
  const { userRates, updateUserRates, disabled, errors } = props;
  const size = useWindowSize();
  const { t } = useTranslation();

  return (
    <div className={styles.desiredPay}>
      {/* <div className={styles.title}>Terms</div> */}

      <div className="">
        <div className={styles.subtitle}>{t('dashboard.profile.details.pay')}</div>
        <select
          value={userRates?.Currency}
          onChange={(e) => updateUserRates({ ...userRates, Currency: e.target.value })}
          className={styles.currencyFilter}
          disabled={disabled}
        >
          {Currency?.map((currency) => (
            <option key={currency} value={currency}>
              {currency}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.contractWork}>
        <div className={styles.subtitle}>{t('profile.builder.contractwork')}</div>
        <div className={styles.wageInputs}>
          <PartialReadOnlyInput
            onChange={(e) => updateUserRates({ ...userRates, Hourly: e.target.value?.replace(/[^0-9]/g, '') })}
            containerSize="containerWidthSm"
            inputSize="inputWidthSm"
            labelPosition="labelCenter"
            title={t('dashboard.profile.details.hourly')}
            amount={userRates?.Hourly}
            unit="/ hr"
            disabled={disabled}
            error={errors?.hourly}
          />
          <PartialReadOnlyInput
            onChange={(e) => updateUserRates({ ...userRates, Daily: e.target.value?.replace(/[^0-9]/g, '') })}
            containerSize="containerWidthSm"
            inputSize="inputWidthSm"
            labelPosition="labelCenter"
            title={t('dashboard.profile.details.daily')}
            amount={userRates?.Daily}
            unit={`/ ${t('common.general.day')}`}
            disabled={disabled}
            error={errors?.daily}
          />
        </div>
      </div>

      <div className={styles.annualSalary}>
        <div className={styles.subtitle}>{t('dashboard.profile.details.permenant')}</div>
        <PartialReadOnlyInput
          onChange={(e) => updateUserRates({ ...userRates, Annual: e.target.value?.replace(/[^0-9]/g, '') })}
          containerSize={size.width < maxMobileSize ? 'containerWidthSm' : 'containerWidthLg'}
          inputSize={size.width < maxMobileSize ? 'inputWidthSm' : 'inputWidthLg'}
          labelPosition="labelStart"
          title={t('dashboard.profile.details.annualsalary')}
          amount={userRates?.Annual}
          unit={`/ ${t('common.general.year')}`}
          disabled={disabled}
          error={errors?.annual}
        />
      </div>
    </div>
  );
}

export default Terms;
